function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.667 0a1 1 0 00-1 1v29.667a1.333 1.333 0 002.666 0V20c0-.368.298-.667.667-.667h2.333A1.658 1.658 0 0027 17.685V17.657C26.915 8.073 23.776 0 20.667 0zM14.333 0C13.597 0 13 .597 13 1.333V8a2.66 2.66 0 01-.761 1.867.334.334 0 01-.572-.234v-8.3a1.333 1.333 0 00-2.666 0V9.63a.334.334 0 01-.572.233 2.657 2.657 0 01-.761-1.864V1.332a1.333 1.333 0 00-2.666 0v6.667a5.344 5.344 0 003.556 5.029.666.666 0 01.444.628v17.009a1.333 1.333 0 002.666 0V13.656c0-.282.178-.534.444-.628a5.345 5.345 0 003.556-5.029V1.332c0-.736-.597-1.333-1.333-1.333z"
});

function SvgRestaurant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgRestaurant;